import script from "./EmptyCont.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyCont.vue?vue&type=script&setup=true&lang=js"

import "./EmptyCont.vue?vue&type=style&index=0&id=fc01279e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc01279e"]])

export default __exports__